import { client } from "@/api/client";
import interceptors from "@/api/interceptor";

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function getBanner(params) {
	return client.get("banner/data", {
		params: params,
	});
}

export default {
	getBanner
};